<div class="ds-tabs">
  <div class="ds-tabs__heads" [class.with-border]="withBorder" 
       [style.--tabs-container-width]="tabsContainerWidth + 'px'">
    <div>
      <ng-content select="ds-tab-head"></ng-content>
      <span class="ds-tabs__sliding-indicator"
           [style.transform]="'translateX(' + indicatorPosition + 'px)'"
           [style.width]="indicatorWidth + 'px'"></span>
    </div>
  </div>

  <div class="ds-tabs__main-content">
    <ng-container *ngTemplateOutlet="beforeContent"></ng-container>
    <div class="ds-tabs__contents">
      <ng-content select="ds-tab-content"></ng-content>
    </div>
  </div>
</div>

<!-- usage
<ds-tabs class="ds-account__tabs" [activeTabId]="activeTab.value" (onActiveTabChange)="accountsTabChange($event)" >
  <ds-tab-head [tabId]="'tab1'" [activeTabId]="activeTab.value">
    <span class="ds-account__sidebar-link">{{'text_personalInformation' | dbText}}</span>
  </ds-tab-head>
  <ds-tab-head [tabId]="'tab2'" [activeTabId]="activeTab.value">
    <span class="ds-account__sidebar-link">{{'text_accountSecurity' | dbText}}</span>
  </ds-tab-head>
  <ds-tab-content [tabId]="'tab1'" [activeTabId]="activeTab.value">
    account-settings
  </ds-tab-content>
  <ds-tab-content [tabId]="'tab2'" [activeTabId]="activeTab.value">
    security
  </ds-tab-content>
</ds-tabs>
-->

